import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
} from '@mui/material';

/**
 * Port quase 1:1 de `DialogInstrucaoInicial.jsx` real (já MUI v5 em
 * produção) — só troca o wrapper `DialogNew`/`HeaderInstrucao` por
 * `Dialog`/`DialogTitle`/`DialogContent`/`DialogActions` do MUI v5, mesmo
 * padrão já estabelecido em `DialogSimularQuitacao.jsx`.
 */
export default function DialogInstrucaoInicial({ open, texto, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth hideBackdrop>
      <DialogTitle>Instrução Inicial</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          disabled
          value={texto || ''}
          sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#000000' } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>OK, ENTENDI</Button>
      </DialogActions>
    </Dialog>
  );
}

DialogInstrucaoInicial.propTypes = {
  open: PropTypes.bool,
  texto: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

DialogInstrucaoInicial.defaultProps = {
  open: false,
  texto: '',
};
